"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryFieldKey = void 0;
// eslint-disable-next-line no-shadow
var QueryFieldKey;
(function (QueryFieldKey) {
    //GENERIC
    QueryFieldKey["KEYWORD"] = "keyword";
    QueryFieldKey["OP"] = "op";
    QueryFieldKey["OPDEFINITION"] = "opDefinition";
    QueryFieldKey["ORGANISATION"] = "organisation";
    QueryFieldKey["PLACE"] = "place";
    QueryFieldKey["POSITION"] = "position";
    QueryFieldKey["STAFF"] = "staff";
    QueryFieldKey["TEAM"] = "team";
    QueryFieldKey["TEMPLATE"] = "template";
    QueryFieldKey["ORGTEMPLATE"] = "org_template";
    QueryFieldKey["SHOW_MINE_ONLY"] = "showMineOnly";
    QueryFieldKey["ISSUE_CREATED_BY_ME"] = "showCreatedByMe";
    // ASSET
    QueryFieldKey["ASSET"] = "asset";
    QueryFieldKey["ASSET_SENSOR_TEMPERATURE"] = "assetSensorTemperature";
    QueryFieldKey["ASSET_SENSOR_HUMIDITY"] = "assetSensorHumidity";
    QueryFieldKey["ASSET_SENSOR_WATER_PRESENT"] = "assetSensorWaterPresent";
    QueryFieldKey["ASSET_SENSOR_OBJECT_PRESENT"] = "assetSensorObjectPresent";
    QueryFieldKey["ASSET_TYPE"] = "assetType";
    QueryFieldKey["ASSET_MANUFACTURER"] = "manufacturer";
    QueryFieldKey["ASSET_MODEL"] = "model";
    QueryFieldKey["ASSET_SERIALNO"] = "serialNo";
    QueryFieldKey["ASSET_HASSENSOR"] = "hasSensor";
    QueryFieldKey["ASSET_LASTSERVICEDATE"] = "lastServiceDate";
    QueryFieldKey["ASSET_CUSTOMFIELD_0"] = "customField0";
    QueryFieldKey["ASSET_CUSTOMFIELD_1"] = "customField1";
    QueryFieldKey["ASSET_CUSTOMFIELD_2"] = "customField2";
    QueryFieldKey["ASSET_CUSTOMFIELD_3"] = "customField3";
    QueryFieldKey["ASSET_CUSTOMFIELD_4"] = "customField4";
    QueryFieldKey["ASSET_CUSTOMFIELD_5"] = "customField5";
    QueryFieldKey["ASSET_CUSTOMFIELD_6"] = "customField6";
    QueryFieldKey["ASSET_CUSTOMFIELD_7"] = "customField7";
    QueryFieldKey["ASSET_CUSTOMFIELD_8"] = "customField8";
    QueryFieldKey["ASSET_CUSTOMFIELD_9"] = "customField9";
    //PLACE
    QueryFieldKey["PLACE_TAG"] = "tags";
    QueryFieldKey["PLACE_ENABLED"] = "enabled";
    //CONVERSATION
    QueryFieldKey["CONVERSATION_OP"] = "relatedOp";
    QueryFieldKey["CONVERSATION_ISSUE"] = "relatedIssue";
    // ISSUE
    QueryFieldKey["ISSUE_STATUS"] = "issueStatus";
    QueryFieldKey["ISSUE_DUESTATUS"] = "issueDueStatus";
    QueryFieldKey["ISSUE_RESOLUTIONTIME"] = "issueResolutionTime";
    QueryFieldKey["ISSUE_FLAG"] = "issueFlag";
    QueryFieldKey["ISSUE_TYPE"] = "issueType";
    QueryFieldKey["ISSUE_HASOP"] = "hasOp";
    QueryFieldKey["ISSUE_OCCURRENCEDATE"] = "occurrenceDate";
    QueryFieldKey["ISSUE_DEADLINEDATE"] = "deadlineDate";
    QueryFieldKey["ISSUE_CLOSEDDATE"] = "closedDate";
    QueryFieldKey["ISSUE_CREATEDBY"] = "createdBy";
    QueryFieldKey["ISSUE_ASSIGNEDTO"] = "assignedTo";
    QueryFieldKey["ISSUE_CAUSES"] = "causes";
    QueryFieldKey["ISSUE_CORRECTIVEACTIONS"] = "correctiveActions";
    QueryFieldKey["ISSUE_PREVENTATIVEACTIONS"] = "preventativeActions";
    // OPS GENERIC
    // (OP DEF / OPS / TEMPLATE DEF)
    QueryFieldKey["OPS_TYPE"] = "opType";
    QueryFieldKey["OPS_ADHOC"] = "permitAdhoc";
    QueryFieldKey["OPS_SCHEDULED"] = "scheduled";
    // OP DEF
    QueryFieldKey["OPDEFINITION_HIDDEN"] = "opDefinitionHIDDEN";
    QueryFieldKey["OPDEFINITION_ENABLED"] = "enabled";
    // OP
    QueryFieldKey["OP_STARTFROM"] = "startFrom";
    QueryFieldKey["OP_COMPLETEBY"] = "completeBy";
    QueryFieldKey["OP_ACTUALSTART"] = "actualStart";
    QueryFieldKey["OP_ACTUALCOMPLETE"] = "actualComplete";
    QueryFieldKey["OP_STATUS"] = "opStatus";
    QueryFieldKey["OP_HASISSUES"] = "hasIssues";
    QueryFieldKey["OP_PASSSTATUS"] = "opPassStatus";
    QueryFieldKey["OP_GRADE"] = "opGrade";
    QueryFieldKey["OP_SCORE"] = "score";
    QueryFieldKey["OP_QUESTION"] = "opQuestion";
    QueryFieldKey["OP_ANSWER"] = "opAnswer";
    // ORGANISATION
    QueryFieldKey["ORG_STATUS"] = "orgStatus";
    QueryFieldKey["ORG_TAGS"] = "orgTags";
    // STAFF
    QueryFieldKey["STAFF_WEBSTATUS"] = "inviteStatus";
    QueryFieldKey["STAFF_APPSTATUS"] = "inviteToAppStatus";
    QueryFieldKey["STAFF_TYPE"] = "userType";
    // TASK
    QueryFieldKey["TASK_TYPE"] = "taskType";
    QueryFieldKey["TASK_STATUS"] = "taskStatus";
    // TEMPLATE DEFINITION
    QueryFieldKey["TEMPLATE_SOURCE"] = "source";
    QueryFieldKey["TEMPLATE_CATEGORY"] = "categories";
    QueryFieldKey["INDUSTRY"] = "industry";
    //WORKFLOW
    QueryFieldKey["WORKFLOW_EVENT"] = "event";
    QueryFieldKey["WORKFLOW_ENABLED"] = "enabled";
    QueryFieldKey["WORKFLOW_ACTIONS"] = "actions";
    QueryFieldKey["WORKFLOW_CONDITION"] = "condition";
})(QueryFieldKey = exports.QueryFieldKey || (exports.QueryFieldKey = {}));
exports.default = QueryFieldKey;
